import * as yup from 'yup';

const schema = yup.object().shape({
  name: yup
    .string()
    .required()
    .trim(),
  crmvNumber: yup
    .string()
    .required()
    .trim(),
  crmvUF: yup
    .string()
    .required()
    .trim()
});

export default schema;
